<template>
    <v-app>
        <v-form @submit.prevent="submitForm">
            <v-card max-width="1300px" class="mx-auto">
                <v-card-title><h6 class="font-weight-bold">MODIFIER UNE VILLE</h6></v-card-title>
                <v-card-subtitle>Modification d'une ville</v-card-subtitle>

                <v-card-text>
                    <v-container fluid>
                        <div class="form-group">
                            <label for="inputAddress">Designation de la ville</label>
                            <v-text-field class="col-md-6" dense outlined color="primary" placeholder="Entrer une designation"
                                :error-messages="designationVilleErrors"
                                v-model.trim="$v.ville.designation.$model"
                                @input="$v.ville.designation.$touch()"
                                @blur="$v.ville.designation.$touch()">
                            </v-text-field>
                        </div>
                        <div class="form-row">
                            <div class="form-group col-md-6">
                                <label for="inputCity">Pays</label>
                                <v-select :items="paysList" item-text="designation" 
                                    item-value="id" dense outlined color="teal" 
                                    v-model="ville.paysId">
                                </v-select>
                            </div>
                        </div>
                    </v-container>
                </v-card-text>                

                <v-card-actions>
                    <v-btn x-small color="secondary">REINITIALISER</v-btn>
                    <v-btn x-small type="submit" color="success">MODIFIER</v-btn>
                </v-card-actions>

            </v-card>   
        </v-form>

        <v-alert class="myalert alert-success" type="success" width="350px" dismissible>{{ successMsg }}</v-alert> 
        <v-alert class="myalert alert-warning" type="warning" width="350px" dismissible>{{ warningMsg }}</v-alert>
        <v-alert class="myalert alert-error" type="error" width="350px" dismissible>{{ errorMsg }}</v-alert>
        <v-overlay :value="overlay"><v-progress-circular indeterminate size="64"></v-progress-circular></v-overlay>
    </v-app>
</template>

<script>
import apiService from '@/services/api.service';
import { required } from 'vuelidate/lib/validators'
import { showErrorMessage } from '@/modules/messages/messageProcess';
export default {
    name:"modifierVille",
    data(){
        return{
            overlay : false,
            errorMsg : null,
            warningMsg : null ,
            successMsg : null,

            paysList : [],  
            villeList : [], 

            objectContainList:{
                datas:[]
            },

            ville:{
                designation:null,
                paysId : null
            },
        }
    },

    validations:{
        ville:{
            designation:{
                required
            }
        }

    },

    methods:{

        async readAllVilleFromApi(){
            try {
                const response = await apiService.postForGet('villes/getAllVilles', {});
                const villesList = response.items || [];
                villesList.forEach(element => {
                    if (element.designation == this.$route.params.designation) {
                        this.ville.designation = element.designation;
                        this.ville.paysId = element.paysId;
                    }
                });
            } catch(e) {
                this.errorMsg = e;
                showErrorMessage();
            }
        },
        // RECUPERER LA LISTE DES PAYS DISPONIBLES (avec cache)
        async obtenirListePaysDisponible(){
            try {
                const response = await apiService.postForGet('pays/getAllPays', {});
                this.paysList = response.items || [];
            } catch(e) {
                this.errorMsg = e;
                showErrorMessage();
            }
        },
    },

    computed:{
        // ENSEMBLE DES CONTRAINTES POUR L'ENRGISTREMENT D'UN PAYS
        designationVilleErrors(){
            const errors = [];
            if (!this.$v.ville.designation.$dirty) return errors
            !this.$v.ville.designation.required && errors.push('Veuillez saisir une désignation.')
            return errors
        }

    },

    mounted(){
        this.obtenirListePaysDisponible();
        this.readAllVilleFromApi();
    }
}
</script>

<style scoped>

    .title{
        color: teal;
        font-weight: bold;
    }
    .myalert{
        display: none;
        z-index: 1900;
    }

    .alert-success{
        position: fixed;
        top: 25px;
        right:2%;
        width: 25%;
    }

    .alert-error{
        position: fixed;
        top: 25px;
        right:2%;
        width: 25%;
    }

    .alert-warning{
        position: fixed;
        top: 25px;
        right:2%;
        width: 25%;
    }

</style>